import { Container } from "./styled";

const Well = Container;

export default Well;
